<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
  <mat-card-header>
    <mat-card-title>
      <mat-icon>family_restroom</mat-icon> Other Contacts
    </mat-card-title>
    <mat-card-subtitle>
      View, search and manage non-Hort360 users for Hort360 Manager use only.
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <app-grower-others #othersComponent (selected)="othersComponent.addOther($event.id)" class="w-100"></app-grower-others>
  </mat-card-content>
</mat-card>

